import apiClient from './client';

/**
 * Demo API
 * Endpoints for demo mode functionality
 */

/**
 * Check if demo mode is enabled (public)
 */
export const getDemoStatus = async () => {
  const response = await apiClient.get('/demo/status');
  return response.data;
};

/**
 * Demo login (public)
 */
export const demoLogin = async (data) => {
  const response = await apiClient.post('/demo/login', data);
  return response.data;
};

/**
 * Get demo configuration (super admin only)
 */
export const getDemoConfig = async () => {
  const response = await apiClient.get('/demo/config');
  return response.data;
};

/**
 * Update demo configuration (super admin only)
 */
export const updateDemoConfig = async (data) => {
  const response = await apiClient.put('/demo/config', data);
  return response.data;
};
